<template>
  <div class="front-container">
    <!-- 导航栏 -->
    <nav class="navbar">
      <div class="navbar-inner">
        <!-- Logo -->
        <div class="navbar-brand">
          <div class="brand-icon">
            <img src="@/assets/jenkins.png" alt="Logo" />
          </div>
          <div>
            <div class="brand-name">极客码艺-毕设管家</div>
            <div class="brand-sub">GEEK CODING STUDIO</div>
          </div>
        </div>

        <!-- 桌面端菜单 -->
        <div class="navbar-links">
          <a :class="['nav-link', $route.path === '/home' ? 'active' : '']" @click="navigateToPage('/home')">关于我们</a>
          <a :class="['nav-link', isHelperPage ? 'active' : '']" @click="handleHelperClick">论文助手</a>
          <a :class="['nav-link', $route.path === '/custom' ? 'active' : '']" @click="navigateToPage('/custom')">程序定制</a>
          <a :class="['nav-link', $route.path === '/highlights' ? 'active' : '']" @click="navigateToPage('/highlights')">项目亮点</a>
          <!-- <a :class="['nav-link', $route.path === '/annual-reports' ? 'active' : '']" @click="navigateToPage('/annual-reports')">历年报表</a> -->
          <a :class="['nav-link', $route.path === '/guide' ? 'active' : '']" @click="navigateToPage('/guide')">防骗指南</a>
          <a v-if="user" :class="['nav-link', $route.path === '/message' ? 'active' : '']" @click="navigateToPage('/message')">留言墙</a>
        </div>

        <!-- 快速联系按钮 -->
        <button class="contact-btn desktop-only" @click="showContact = true">快速联系</button>

        <!-- 移动端菜单按钮 -->
        <button class="mobile-menu-btn" @click="toggleMobileMenu">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="24" height="24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
          </svg>
        </button>
      </div>

      <!-- 移动端展开菜单 -->
      <div class="mobile-menu" v-show="isMobileMenuVisible">
        <div class="mobile-menu-body">
          <a class="mobile-nav-link" @click="navigateToPage('/home')">关于我们</a>
          <a class="mobile-nav-link" @click="handleHelperClick">论文助手</a>
          <a class="mobile-nav-link" @click="navigateToPage('/custom')">程序定制</a>
          <a class="mobile-nav-link" @click="navigateToPage('/highlights')">项目亮点</a>
          <!-- <a class="mobile-nav-link" @click="navigateToPage('/annual-reports')">历年报表</a> -->
          <a class="mobile-nav-link" @click="navigateToPage('/guide')">防骗指南</a>
          <a v-if="user" class="mobile-nav-link" @click="navigateToPage('/message')">留言墙</a>
          <button class="contact-btn mobile-full" @click="showContact = true; isMobileMenuVisible = false">快速联系</button>
        </div>
      </div>
    </nav>

    <div class="content-container">
      <router-view/>
    </div>
    <Footer v-if="!isHelperPage"/>

    <!-- 登录模态框 -->
    <LoginModal 
      :visible.sync="showLoginModal" 
      @login-success="handleLoginSuccess"
      @switch-to-register="switchToRegister"
    />

    <!-- 注册模态框 -->
    <RegisterModal 
      :visible.sync="showRegisterModal"
      @register-success="handleRegisterSuccess"
      @switch-to-login="switchToLogin"
    />

    <!-- 快速联系模态框 -->
    <ContactModal :visible.sync="showContact" />
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import LoginModal from "@/components/LoginModal";
import RegisterModal from "@/components/RegisterModal";
import ContactModal from "@/components/ContactModal";

export default {
  name: "Front",
  components: { Footer, LoginModal, RegisterModal, ContactModal },
  data() {
    return {
      isMobileMenuVisible: false,
      showContact: false,
      showLoginModal: false,
      showRegisterModal: false,
      user: null
    }
  },
  created() {
    this.loadUser()
  },
  watch: {
    '$route'() {
      this.loadUser()
    },
    // 监听 store 中的登录弹窗状态
    '$store.state.showLoginModal'(newVal) {
      if (newVal) {
        this.showLoginModal = true
        // 重置 store 中的状态
        this.$store.commit('setShowLoginModal', false)
      }
    }
  },
  computed: {
    isHelperPage() {
      return this.$route.path.startsWith('/helper')
    }
  },
  methods: {
    loadUser() {
      const userStr = localStorage.getItem('user')
      this.user = userStr ? JSON.parse(userStr) : null
    },
    handleLoginSuccess(userData) {
      this.user = userData
      this.showLoginModal = false
    },
    handleRegisterSuccess() {
      this.showRegisterModal = false
      this.showLoginModal = true
    },
    switchToRegister() {
      this.showLoginModal = false
      this.showRegisterModal = true
    },
    switchToLogin() {
      this.showRegisterModal = false
      this.showLoginModal = true
    },
    toggleMobileMenu() {
      this.isMobileMenuVisible = !this.isMobileMenuVisible
    },
    navigateToPage(path) {
      this.$router.push(path)
      this.isMobileMenuVisible = false
    },
    async handleHelperClick() {
      // 检测是否为移动端
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768
      
      if (isMobile) {
        // 移动端跳转到提示页面
        this.$router.push('/mobile-not-supported')
        this.isMobileMenuVisible = false
      } else {
        // 检查是否登录
        if (!this.user) {
          this.showLoginModal = true
          this.isMobileMenuVisible = false
          return
        }
        
        // 验证 token 是否有效
        try {
          const res = await this.request.get(`/user/points/${this.user.username}`)
          if (res.code === '401') {
            // token 已过期
            localStorage.removeItem('user')
            this.user = null
            this.showLoginModal = true
            this.isMobileMenuVisible = false
            return
          }
        } catch (error) {
          console.error('验证 token 失败:', error)
          // 如果请求失败，清除用户信息并显示登录框
          localStorage.removeItem('user')
          this.user = null
          this.showLoginModal = true
          this.isMobileMenuVisible = false
          return
        }
        
        // token 有效，正常跳转
        this.navigateToPage('/helper')
      }
    }
  }
}
</script>

<style scoped>
.front-container {
  background: #fff;
  min-height: 100vh;
}

/* ===== 导航栏 ===== */
.navbar {
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
}

.navbar-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding: 12px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Logo */
.navbar-brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.brand-icon {
  width: 40px;
  height: 40px;
  background: #f3f4f6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.brand-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.brand-name {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
}

.brand-sub {
  font-size: 12px;
  color: #6b7280;
  letter-spacing: 0.1em;
}

/* 桌面端链接 */
.navbar-links {
  display: flex;
  gap: 32px;
}

.nav-link {
  font-size: 16px;
  color: #4b5563;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.2s;
  padding-bottom: 4px;
  border-bottom: 2px solid transparent;
}

.nav-link:hover {
  color: #2563eb;
}

.nav-link.active {
  color: #2563eb;
  font-weight: 600;
  border-bottom: 2px solid #2563eb;
}

/* 快速联系按钮 */
.contact-btn {
  background: #2563eb;
  color: #fff;
  border: none;
  padding: 8px 20px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}

.contact-btn:hover {
  background: #1d4ed8;
}

/* 移动端菜单按钮 */
.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  color: #4b5563;
  cursor: pointer;
  padding: 4px;
}

.mobile-menu-btn:hover {
  color: #111827;
}

/* 移动端展开菜单 */
.mobile-menu {
  border-top: 1px solid #e5e7eb;
  background: #f9fafb;
}

.mobile-menu-body {
  padding: 16px 32px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.mobile-nav-link {
  display: block;
  font-size: 14px;
  color: #4b5563;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.2s;
}

.mobile-nav-link:hover {
  color: #111827;
}

.mobile-full {
  width: 100%;
}

/* 响应式 */
@media screen and (max-width: 768px) {
  .navbar-links {
    display: none;
  }

  .desktop-only {
    display: none;
  }

  .mobile-menu-btn {
    display: block;
  }
}

/* ===== 内容区 ===== */
.content-container {
  padding-top: 68px;
  min-height: calc(100vh - 118px);
}

/* ===== 快速联系弹窗 ===== */
.contact-modal {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.contact-box {
  background: #fff;
  padding: 32px 40px;
  text-align: center;
  position: relative;
  min-width: 280px;
}

.modal-close {
  position: absolute;
  top: 12px;
  right: 16px;
  background: none;
  border: none;
  font-size: 18px;
  color: #9ca3af;
  cursor: pointer;
}

.modal-close:hover { color: #374151; }

.modal-title {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 20px;
}

.modal-qrcode {
  position: relative;
  display: inline-block;
  cursor: pointer;
  margin-bottom: 16px;
}

.modal-qrcode img {
  width: 200px;
  height: 200px;
  object-fit: contain;
  display: block;
}

.modal-tip {
  position: absolute;
  bottom: -28px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0,0,0,0.65);
  color: #fff;
  font-size: 12px;
  padding: 3px 10px;
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.2s;
  pointer-events: none;
}

.modal-qrcode:hover .modal-tip { opacity: 1; }

.modal-wechat {
  font-size: 14px;
  color: #6b7280;
  margin: 12px 0 0;
}

.modal-wechat span {
  color: #2563eb;
  font-weight: 600;
}
</style>
